import React from 'react';
import { Typography, SxProps, Theme } from '@mui/material';
import { RICH_MEDIA_SHARE_SIZE_HINT, RICH_MEDIA_SHARE_SIZE_HINT_LONG } from '../../constants/richMediaShareImage';

interface RichMediaShareSizeHintProps {
    /** Render inline after a field label (e.g. "Feature image · 1200×630 …"). */
    inline?: boolean;
    /** Use the longer recommended-size copy. */
    long?: boolean;
    sx?: SxProps<Theme>;
}

export function RichMediaShareSizeHint({ inline = false, long = false, sx }: RichMediaShareSizeHintProps) {
    const text = long ? RICH_MEDIA_SHARE_SIZE_HINT_LONG : RICH_MEDIA_SHARE_SIZE_HINT;

    if (inline) {
        return (
            <Typography
                component="span"
                sx={{
                    ml: 0.75,
                    fontWeight: 400,
                    fontSize: '0.85em',
                    opacity: 0.55,
                    letterSpacing: 'normal',
                    textTransform: 'none',
                    ...sx,
                }}>
                · {text}
            </Typography>
        );
    }

    return <Typography sx={{ fontSize: 12, opacity: 0.55, mt: 0.75, ...sx }}>{text}</Typography>;
}
